import { FILE_TYPES, VIRTUAL_FILE_MIME } from '../../constants';

export class FileUtils {
    public static openFile(file: Blob, target = '_blank', newWindow?: Window): void {
        const url = window.URL.createObjectURL(file);

        if (newWindow) {
            newWindow.location = url;
        } else {
            window.open(url, target);
        }
    }

    public static base64toBlob(base64: string, fileMimeType: string): Blob {
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: fileMimeType });
    }

    public static getFileType($event): string {
        try {
            if ($event.dataTransfer.items[0].type === VIRTUAL_FILE_MIME) {
                return FILE_TYPES.VIRTUAL;
            }
            return FILE_TYPES.FILE;
        } catch {
            return FILE_TYPES.FILE;
        }
    }
}
